import { render, staticRenderFns } from "./ui-modal.vue?vue&type=template&id=dc77128a"
import script from "./ui-modal.vue?vue&type=script&lang=ts"
export * from "./ui-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports